import axios from 'axios'
import SimpleWebWorker from 'simple-web-worker'
import { request, response } from './consts'

let opts = {}
if (window.location.href.indexOf('mock=1') === -1) {
  opts.baseURL = process.env.SERVICES_URL
} else {
  opts.baseURL = process.env.MOCK_SERVICES_URL
}

const ax = axios.create(opts)

ax.transformRequest = (data, dict = null) => {
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  }
  dict = dict || request
  return SimpleWebWorker.run(
    (data, dict) => {
      for (let prop in dict) {
        data = data.replace(
          new RegExp('"' + prop + '"', 'g'),
          '"' + dict[prop] + '"'
        )
      }
      return JSON.parse(data)
    },
    [data, dict]
  )
}

ax.transformResponse = (data, dict = null) => {
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  }
  dict = dict || response
  return SimpleWebWorker.run(
    (jsonStr, dict) => {
      function isObject(arg) {
        if (arg) {
          const type = Object.prototype.toString.call(arg)
          return type.indexOf('Object') !== -1
        }
        return false
      }

      function isArray(arg) {
        if (arg) {
          const type = Object.prototype.toString.call(arg)
          return type.indexOf('Array') !== -1
        }
        return false
      }

      function iterateNodes(data) {
        let returnObj = isArray(data) ? [] : {}
        for (let prop in data) {
          if (data.hasOwnProperty(prop) && prop.match(/^[A-Z0-9]/)) {
            if (!!data[prop] && (isObject(data[prop]) || isArray(data[prop]))) {
              returnObj[prop] = iterateNodes(data[prop])
            } else {
              returnObj[prop] = data[prop]
            }
          }
        }
        return returnObj
      }

      for (let prop in dict) {
        jsonStr = jsonStr.replace(
          new RegExp('"' + prop + '"', 'g'),
          '"' + dict[prop] + '"'
        )
      }
      let json = {}
      try {
        json = JSON.parse(jsonStr)
      } catch (e) {}
      let data = iterateNodes(json)
      return data
    },
    [data, dict]
  )
}

export default ax



// WEBPACK FOOTER //
// ./src/store/axios.js